import React, { useState } from 'react';
import {
  Box, Button, TextField, Typography, Link,
  CircularProgress, Alert, Paper, IconButton, InputAdornment
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../supabaseClient';
import * as ROUTES from '../../routes/routes';

const LoginView = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMsg('');

    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    setLoading(false);

    if (error) {
      setErrorMsg(error.message);
    } else {
      navigate(ROUTES.OFFICES);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#f5f6fa',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        px: 2,
      }}
    >
      <Paper elevation={3} sx={{ p: 4, width: '100%', maxWidth: 400, textAlign: 'center' }}>
        {/* <Avatar sx={{ 
          bgcolor: '#3d475d', 
          mx: 'auto', 
          mb: 2, 
          width: 56, 
          height: 56 
        }}>
          <Typography variant="h6" sx={{ color: 'white' }}>CLF</Typography>
        </Avatar>
        */}
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Iniciar sesión
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Ingrese sus credenciales para acceder a su cuenta
        </Typography>

        <form onSubmit={handleLogin}>
          <TextField
            fullWidth
            label="Correo electrónico"
            type="email"
            placeholder="correo@ejemplo.com"
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            sx={{
              '& .MuiOutlinedInput-root': {
                '&.Mui-focused fieldset': {
                  borderColor: '#3d475d',
                },
              },
              '& .MuiInputLabel-root': {
                '&.Mui-focused': {
                  color: '#3d475d',
                },
              },
            }}
          />

          <TextField
            fullWidth
            label="Contraseña"
            type={showPassword ? 'text' : 'password'}
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            sx={{
              '& .MuiOutlinedInput-root': {
                '&.Mui-focused fieldset': {
                  borderColor: '#3d475d',
                },
              },
              '& .MuiInputLabel-root': {
                '&.Mui-focused': {
                  color: '#3d475d',
                },
              },
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                    aria-label="toggle password visibility"
                    sx={{
                      color: '#3d475d',
                      '&:hover': {
                        backgroundColor: 'rgba(61, 71, 93, 0.04)',
                      }
                    }}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />

          <Box textAlign="right" sx={{ mt: 1 }}>
            <Link
              onClick={() => navigate(ROUTES.FORGOT_PASSWORD)}
              underline="hover"
              variant="caption"
              sx={{ 
                cursor: 'pointer',
                color: '#3d475d',
                '&:hover': {
                  color: '#2c3441',
                }
              }}
            >
              ¿Olvidó su contraseña?
            </Link>
          </Box>

          {errorMsg && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {errorMsg}
            </Alert>
          )}

          <Button
            fullWidth
            type="submit"
            variant="contained"
            sx={{ 
              mt: 3,
              backgroundColor: '#3d475d',
              color: 'white',
              '&:hover': {
                backgroundColor: '#2c3441',
              },
              '&:active': {
                backgroundColor: '#1e252f',
              },
              '&:disabled': {
                backgroundColor: '#8a94a8',
                color: 'rgba(255, 255, 255, 0.7)',
              }
            }}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} sx={{ color: 'rgba(255, 255, 255, 0.7)' }} />
            ) : (
              'Iniciar sesión'
            )}
          </Button>
        </form>

         <Typography variant="body2" sx={{ mt: 3 }}>
          ¿Desea asociarse con nosotros?{' '}
          <Link
            onClick={() => navigate(ROUTES.CLIENT_APPLY)}
            underline="hover"
            sx={{ 
              cursor: 'pointer',
              color: '#3d475d',
              '&:hover': {
                color: '#2c3441',
              }
            }}
          >
            Solicite aquí
          </Link>
        </Typography>

        <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: 'block' }}>
          Al iniciar sesión, acepta nuestros{' '}
          <Link 
            href="#" 
            underline="hover"
            sx={{
              color: '#3d475d',
              '&:hover': {
                color: '#2c3441',
              }
            }}
          >
            Términos de servicio
          </Link> y{' '}
          <Link 
            href="#" 
            underline="hover"
            sx={{
              color: '#3d475d',
              '&:hover': {
                color: '#2c3441',
              }
            }}
          >
            Política de privacidad
          </Link>
        </Typography>
      </Paper>
    </Box>
  );
};

export default LoginView;